import { useParams } from "react-router-dom";
import VlogViewer from "./VlogViewer";

const VlogViewerFromUrl = () => {
  const params = useParams();
  const vlogId = params["*"];

  // Format the vlog ID based on its type
  const formatVlogId = (id) => {
    if (!id) return "";

    // Remove any leading slashes
    const cleanId = id.replace(/^\/+/, "");

    // Handle LeetCode vlogs
    if (cleanId.includes("LeetCode")) {
      return cleanId;
    }

    // Handle TechSeries vlogs
    if (cleanId.includes("TechSeries")) {
      return cleanId;
    }

    // Handle other vlogs
    if (!cleanId.startsWith("Vlogs/")) {
      return `Vlogs/${cleanId}`;
    }

    return cleanId;
  };

  const formattedVlogId = formatVlogId(vlogId);

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-9">
          <VlogViewer selectedVlog={formattedVlogId} />
        </div>
      </div>
    </div>
  );
};

export default VlogViewerFromUrl;
